export const NO_FREIGHT = 9;
